
import Vue from 'vue'

export default Vue.extend({
  data() {
    return {
      windowWidth: innerWidth,
      verticalThrethold: 0.751,
      isActiveVerticalAlert: false
    }
  },
  watch: {
    windowWidth(newVal) {
      if (this.isVertical(newVal)) {
        this.isActiveVerticalAlert = true
      } else {
        this.isActiveVerticalAlert = false
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.resetWidth, false)
    if (this.isVertical(window.innerWidth)) {
      this.isActiveVerticalAlert = true
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resetWidth, false)
  },
  methods: {
    resetWidth() {
      this.windowWidth = window.innerWidth
    },
    isVertical(width: number): boolean {
      return window.innerHeight / width > this.verticalThrethold
    }
  }
})
